import pino, { type Logger, type LoggerOptions } from 'pino';

const isBrowser = typeof window !== 'undefined';
const env = (typeof process !== 'undefined' ? process.env : {}) ?? {};
const level = env.LOG_LEVEL ?? 'info';
const prettyPrint = env.LOG_PRETTY_PRINT === 'true';

const baseOptions: LoggerOptions = {
	level,
	base: { service: 'trueflag-web' },
	formatters: {
		level: (label) => ({ level: label })
	}
};

const buildLogger = (): Logger => {
	if (isBrowser) return pino(baseOptions);

	const serverOptions: LoggerOptions = {
		...baseOptions,
		timestamp: pino.stdTimeFunctions.isoTime
	};

	if (prettyPrint) {
		serverOptions.transport = {
			target: 'pino-pretty',
			options: {
				colorize: true,
				translateTime: 'SYS:standard',
				ignore: 'pid,hostname'
			}
		};
	}

	return pino(serverOptions);
};

const logger = buildLogger();

export default logger;
